
import { Checkbox } from "@/components/ui/checkbox";

export interface PaymentStatus {
  id: string;
  label: string;
}

export const PAYMENT_STATUS_FILTERS = [
  { id: "paid", label: "Adhésion confirmée" },
  { id: "not_paid", label: "Adhésion non confirmée" },
];

interface PaymentStatusFilterProps {
  selectedStatuses: string[];
  onStatusChange: (statusId: string) => void;
}

export const PaymentStatusFilter = ({
  selectedStatuses,
  onStatusChange,
}: PaymentStatusFilterProps) => {
  return (
    <div>
      <h4 className="text-sm font-semibold mb-2">Statut de paiement</h4>
      <div className="flex flex-wrap gap-4 mb-4">
        {PAYMENT_STATUS_FILTERS.map((status) => (
          <div key={status.id} className="flex items-center space-x-2">
            <Checkbox 
              id={`status-${status.id}`}
              checked={selectedStatuses.includes(status.id)}
              onCheckedChange={() => onStatusChange(status.id)}
            />
            <label
              htmlFor={`status-${status.id}`}
              className="text-sm font-medium leading-none peer-disabled:cursor-not-allowed peer-disabled:opacity-70"
            >
              {status.label}
            </label>
          </div>
        ))}
      </div>
    </div>
  );
};
